import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Video_Overlays/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaPerm';
import VideoOverlayTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Video_Overlays/videoOverlayTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  VideoOverlayTable,
  BreadCrumbs,
  SEOHelmet,
  React
};